import React from 'react'
import { withIcon } from '../../withIcon'

const VIEWBOX_W = 11
const VIEWBOX_H = 12

function toHeightPx (size) {
  if (typeof size === 'number') return size
  const n = parseFloat(String(size).replace(/px$/i, ''))
  return Number.isFinite(n) ? n : 24
}

function LearnerLevelIntermediateIcon (props) {
  const {
    size = 24,
    color = '#000000',
  } = props

  const heightPx = toHeightPx(size)
  const widthPx = heightPx * (VIEWBOX_W / VIEWBOX_H)

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={`${widthPx}px`} height={`${heightPx}px`} viewBox={`0 0 ${VIEWBOX_W} ${VIEWBOX_H}`} fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.80558 5.38977C5.23762 5.03768 5.87464 5.06333 6.27726 5.46594L10.6776 9.86536C11.1072 10.2949 11.107 10.9914 10.6776 11.421C10.2481 11.8506 9.55156 11.8506 9.12198 11.421L5.49991 7.79895L1.87784 11.421C1.44826 11.8506 0.751754 11.8506 0.322177 11.421C-0.107368 10.9914 -0.107389 10.2949 0.322177 9.86536L4.72159 5.46594L4.80558 5.38977ZM4.80558 0.246218C5.23762 -0.105871 5.87464 -0.080232 6.27726 0.32239L10.6776 4.7218C11.1072 5.15133 11.107 5.84787 10.6776 6.27747C10.2481 6.70705 9.55156 6.70705 9.12198 6.27747L5.49991 2.6554L1.87784 6.27747C1.44826 6.70705 0.751754 6.70705 0.322177 6.27747C-0.107388 5.84789 -0.107396 5.15138 0.322177 4.7218L4.72159 0.32239L4.80558 0.246218Z"
        fill={color}
      />
    </svg>
  )
}

export default withIcon(LearnerLevelIntermediateIcon)
